export const envLabel = (env: "sandbox" | "production") =>
  env === "production" ? "Production" : "Sandbox";

export const statusBadgeVariant = (
  status: string
): "success" | "destructive" | "warning" | "secondary" => {
  if (status === "allowed" || status === "approved") return "success";
  if (status === "denied" || status === "rejected" || status === "expired") return "destructive";
  if (status === "pending_approval" || status === "modify_required") return "warning";
  return "secondary";
};

export const statusLabel: Record<string, string> = {
  allowed: "Allowed",
  denied: "Denied",
  pending_approval: "Pending approval",
  approved: "Approved",
  rejected: "Rejected",
  modify_required: "Modify required",
  expired: "Expired"
};

export const formatRequestStatus = (status: string) => statusLabel[status] ?? status;

export type Actor =
  | { type: "user"; id: string; label: string; email: string | null; name: string | null }
  | {
      type: "api_key";
      id: string;
      label: string;
      name: string;
      prefix: string;
      environment: string;
    }
  | { type: "system"; id: null; label: "system" }
  | { type: "unknown"; id: string | null; label: string };

export const actorBadgeVariant = (type: Actor["type"]): "default" | "secondary" | "outline" => {
  if (type === "user") return "default";
  if (type === "api_key") return "secondary";
  return "outline";
};

export const formatActorLabel = (actor: Actor) => {
  const prefix =
    actor.type === "user"
      ? "user"
      : actor.type === "api_key"
        ? "key"
        : actor.type === "system"
          ? ""
          : "";
  return prefix.length > 0 ? `${prefix}: ${actor.label}` : actor.label;
};

export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString([], {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });

export const formatDateTimeShort = (iso: string) =>
  new Date(iso).toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
